<template>
  <div>
    <table id="table" :class="{stripe:stripe}" :style="styles.table">
      <thead v-if="data.thead">
        <tr :style="styles.th_tr">
          <th v-for="(key) in data.sort" :key="key">{{data.thead[key]}}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="obj in data.tbody" :key="obj.name" :style="styles.tb_tr">
          <td v-for="(key) in data.sort" :key="key">{{obj[key]}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "createTable",
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },

    styles: {
      type: Object,
      default: function() {
        return {};
      }
    },

    stripe: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style scope lang="less">
#table {
  min-width: 700px;
  margin: 50px auto 0;
  border-collapse: collapse;
  font-size: 14px;

  box-shadow: 3px 3px 5px rgb(179, 179, 181, 0.5),
    -3px -3px 5px rgb(179, 179, 181, 0.5);

  thead {
    tr {
      height: 30px;
      th {
        border: 1px black solid;
      }
    }
  }

  tbody {
    tr {
      height: 40px;
      td {
        border: 1px black solid;
        text-align: center;
      }
    }
  }
}

.stripe {
  tbody {
    tr:nth-child(odd) {
      background: rgb(240, 241, 243);
    }
  }
}
</style>